<template>
    <div class="bg-info full-width text-black container">
        <template v-if="shippingType == ShippingType.DELIVERY">
            <div class="text-subtitle1">Deliver from</div>
            <template v-if="loading">Load delivery distance...</template>
            <template v-else-if="error">
                {{ error }}
            </template>
            <template v-else>
                <template v-if="branchList.length > 0">
                    <div
                        :class="
                            showBorder
                                ? `bg-white q-pa-xs border`
                                : `bg-white q-pa-xs`
                        "
                    >
                        <div>Customer address can be delivered from</div>
                        <div class="row">
                            <q-chip
                                dense
                                v-for="(item, index) in branchList"
                                :key="`${item}${index}`"
                                clickable
                                @click="onChooseBranch(item)"
                                color="primary"
                                text-color="white"
                                square
                                :outline="currentBranch !== item.br_code"
                            >
                                {{ item.store_name }}
                            </q-chip>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div>Customer address is nationwide delivery</div>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import { ShippingType } from "@/entities/order/order";
import { mapState, mapGetters } from "vuex";
import { mini, getBranchAddress } from "@/settings/branchs";
export default {
    name: "DeliverFrom",
    data() {
        return {
            ShippingType: ShippingType,
            loading: false,
            error: null,
        };
    },
    computed: {
        ...mapState({
            shippingType: (state) => state["checkout"]["shippingType"],
            branchList: (state) => state["checkout"]["branchList"],
        }),
        currentBranch() {
            const branch = this.$store.state["branch"]["branch"];
            if (branch) {
                return parseInt(branch.code);
            }
            return null;
        },
        showBorder() {
            const branchCodeList = this.branchList.map((x) => x.br_code);
            console.log({ branchCodeList });
            if (branchCodeList.indexOf(this.currentBranch) >= 0) {
                return false;
            }
            return true;
        },
    },
    methods: {
        async onChooseBranch(branch) {
            console.log("onChooseBranch");

            if (this.currentBranch === branch.br_code) {
                return;
            }

            // switch branch
            const b = getBranchAddress(branch.store_name);
            await this.$store.dispatch("branch/setBranch", b);
            await this.$store.dispatch("checkout/getCost");
        },
    },
};
</script>

<style scoped>
.container {
    padding: 0px 8px;
}
.border {
    border: 2px solid #ed7246;
    border-radius: 4px;
}
</style>
